<script>
    import { createEventDispatcher } from 'svelte';

    export let letterFilterArr = [];

    export let clickedLetter;

    const dispatch = createEventDispatcher();

    const letters = Array.from(Array(26), (_, i) => String.fromCharCode(i + 65)); // Generate an array of letters A-Z

    function handleClick(letter,event) {
        event.preventDefault();
        dispatch('click', letter); // Dispatch a 'click' event with the clicked letter as data
    }

    console.log('letterFilterArr: ', letterFilterArr)
</script>

<div class="letter-links mt-3 pt-2 border-top">
    <ul class="p-0 m-0 list-unstyled d-flex flex-wrap flex-xl-nowrap justify-content-center" aria-label="Filter database names by A to Z">
        <li>
            <button aria-label="all databases" class="keynav" tabindex="0" on:click={(event) => handleClick("all", event)}>All</button>
        </li>
        {#each letters as letter, index}
                <li>
                    <button aria-label="{letter}"
                            class="keynav"
                            class:active="{clickedLetter === letter}"
                            on:click={(event) => handleClick(letter, event)}
                            tabindex="-1"
                    >{letter}</button>
                </li>

        {/each}
    </ul>
</div>
